export default __webpack_public_path__ + "static/media/event_blue.ddd279bd.svg";